import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import IconButton from '@material-ui/core/IconButton'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import TreeList from '../../../../../../../components/_shared/customTree/TreeList'
import { TREE_LEVELS } from '../../../../../../../services/constants'

const styles = {
  modalTitleContainer: {
    position: 'relative' as const,
    paddingRight: '48px',
  },
  closeButton: {
    position: 'absolute' as const,
    right: 8,
    top: 8,
  },
  dialogActions: {
    padding: '16px 24px',
  },
}

type AssignLocationModalProps = {
  classes: {
    modalTitleContainer: string
    closeButton: string
    dialogActions: string
  }
  isOpen: boolean
  modalTitle: string
  actionLabel: string
  onApply: () => void
  onClose: () => void
}

const AssignLocationModal = ({
  classes,
  isOpen,
  modalTitle,
  actionLabel,
  onApply,
  onClose,
}: AssignLocationModalProps) => (
  <Dialog open={isOpen} onClose={onClose} maxWidth="sm" fullWidth>
    <DialogTitle className={classes.modalTitleContainer} disableTypography>
      <Typography variant="h5">{modalTitle}</Typography>
      <IconButton
        className={classes.closeButton}
        aria-label="close"
        onClick={onClose}
      >
        <CloseIcon />
      </IconButton>
    </DialogTitle>
    <DialogContent>
      <TreeList mainLevel={TREE_LEVELS.PROPERTY} />
    </DialogContent>
    <DialogActions className={classes.dialogActions}>
      <Button onClick={onApply} variant="contained" color="primary">
        {actionLabel}
      </Button>
    </DialogActions>
  </Dialog>
)

export default withStyles(styles)(AssignLocationModal)
